import { useChatsUnreadCount } from '../Chat/hooks/useChatsUnreadCount';

export const useInboxCount = () => {
  const totalInbox = useChatsUnreadCount();

  return {
    formattedTotalInbox: totalInbox > 99 ? '99+' : totalInbox,
    totalInbox,
  };
};
